import { useMutation, useQueryClient } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

export const useUploadFile = () => {
  return useMutation({
    mutationKey: ['upload-file'],
    mutationFn: aiStudioService.uploadFile,
  })
}
